import { render, staticRenderFns } from "./PrizeItem.vue?vue&type=template&id=1844f834&scoped=true&"
import script from "./PrizeItem.vue?vue&type=script&lang=js&"
export * from "./PrizeItem.vue?vue&type=script&lang=js&"
import style0 from "./PrizeItem.vue?vue&type=style&index=0&id=1844f834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1844f834",
  null
  
)

export default component.exports